var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPilotChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5028 1.32862c-.1594-.16068-.349-.28821-.5579-.375247-.2089-.087032-.433-.13184-.6593-.13184s-.4504.044808-.6593.13184c-.2089.087037-.3985.214567-.5578.375247l-8.76 8.75998c-.04.0415-.0879.0745-.141.097-.053.0226-.11.0342-.1676.0342s-.1146-.0116-.1676-.0342c-.0531-.0225-.101-.0555-.141-.097L2.93132 1.32862c-.15936-.16068-.34896-.28821-.55787-.375247-.2089-.087032-.43296-.13184-.65927-.13184s-.45037.044808-.65927.13184c-.208906.087037-.398508.214567-.557873.375247-.319287.32119-.49850184.75568-.49850184 1.20857 0 .45289.17921484.88738.49850184 1.20857L10.1828 13.4315c.4821.4815 1.1357.752 1.8171.752s1.335-.2705 1.8171-.752l9.6858-9.68574c.3192-.32119.4985-.75568.4985-1.20857 0-.45289-.1793-.88738-.4985-1.20857Z",
    fill: "#1A4359"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilotChevronDown);
export default __webpack_public_path__ + "static/media/pilot-chevron-down.5ba3fdc8ad252d1a241e1b844668a0d1.svg";
export { ForwardRef as ReactComponent };